import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export const addShortCode = (options: IPickerOption[], currentMessage: string, maxLength?: number) => {
  let newMessage: string = currentMessage;

  if (!newMessage.length || newMessage[newMessage.length - 1] === ' ') {
    newMessage += `${String(options[0].value)} `;
  } else {
    newMessage += ` ${String(options[0].value)} `;
  }

  if (maxLength && newMessage.length > maxLength) return currentMessage;

  return newMessage;
};
